// Constants
import Endpoints from '@/constants/endpoints';
import Constants from '@/constants/constants';

// Services
import $http from '@/core/services/http.service';
import UtilsService from '@/core/services/utils.service';



export default class BillingService {

    public static uploadBillDocument(payload: any) {
        const formData = new FormData();
        formData.append('document', payload.file);
        return $http.patch(Endpoints.billUploadDocument(payload.id), formData);
    }

    public static sendBillEmail(id: string) {
        return $http.post(Endpoints.billDocumentSend(id));
    }

    public static sendChangeDataBillEmail(id: string) {
        return $http.post(Endpoints.billChangeDataSend(id));
    }

    public static refundBill(id: string) {
        return $http.post(Endpoints.billRefund(id));
    }

    // public static setChangeDataExpiration(id: string) {
    //     return $http.post(Endpoints.billChangeDataExpiration(id));
    // }

    public static downloadCsv(filters: any): void {
        filters = { limit: Constants.downloadCsvLimit, ...filters };
        const params = UtilsService.getQueryParamsFormatted(filters);
        const url = `${Endpoints.billDowndloadCsv()}${params}`;
        window.location.href = url;
    }

    public static downloadBillZip(filters: any) {
        const params = UtilsService.getQueryParamsFormatted(filters);
        return $http.get(`${Endpoints.billDowndloadBillZip()}${params}`);
    }

    public static sendAllBills(filters: any) {
        const params = UtilsService.getQueryParamsFormatted(filters);
        return $http.get(`${Endpoints.billSendAllBill()}${params}`);
    }

    public static regenerateBillPdf(filters: any) {
        const params = UtilsService.getQueryParamsFormatted(filters);
        return $http.get(`${Endpoints.regenerateBillPdf()}${params}`);
    }

    public static editBillDates(filters: any) {
        const params = UtilsService.getQueryParamsFormatted(filters);
        return $http.get(`${Endpoints.editBillDates()}${params}`);
    }

}
